// import styles
import "./ListaProgetti.css";

// import pacchetti
import { Link } from "react-router-dom";

// Colori associati a ciascun settore per l'etichetta
export const COLORI_SETTORI = {
  Edile: "#f59e0b",
  Cucine: "#06b6d4",
  Intesa: "#3b82f6",
  Elettrico: "#eab308",
  FTV: "#22c55e",
  ROBY: "#a855f7",
  Amministrazione: "#64748b",
  Cessati: "#ef4444",
  Verona: "#ec4899",
};

const COLORE_DEFAULT = "#94a3b8";

// Restituisce il colore dell'etichetta a partire dal settore
export const coloreSettore = (settore) =>
  COLORI_SETTORI[settore] || COLORE_DEFAULT;

// Verifica se l'utente appartiene al settore degli ex dipendenti
export const isCessato = (user) =>
  String(user?.anagrafica?.settore || "")
    .trim()
    .toLowerCase() === "cessati";

export default function ListaUtenti({ data, visible }) {
  return (
    <div className="project-list">
      {data.length === 0 && <p>Nessun Utente presente</p>}
      {data.map((user) => {
        const settore = user.anagrafica?.settore || null;
        return (
          <Link
            to={`/anagraficaDipendente/${user.id}`}
            key={user.id}
            className={visible || user.isVisible ? "utente-card" : "utente-card nascondi"}
          >
            <h4>
              {user.anagrafica
                ? `${user.anagrafica.nome} ${user.anagrafica.cognome}`
                : user.displayName}
            </h4>
            <span
              className="settore-tag"
              style={{ backgroundColor: coloreSettore(settore) }}
            >
              {settore || "Nessun settore"}
            </span>
          </Link>
        );
      })}
    </div>
  );
}
